<template>
    <v-select
        :class="[
            'vue-select-bulma',
            customClass
        ]"
        v-bind="$props"
        :value="selectValue"
        @input="onInput"
        :disabled="disabled"
        @search="onSearch"
        :multible="multiple"
        :closeOnSelect="closeOnSelect"
        :append-to-body="appendToBody"
        :filter="filter"
        :clearable="clearable"
    >
        <span slot="no-options">Ingen resultater fundet</span>
    </v-select>
</template>

<script>
import vSelect from 'vue-select'
export default {

    name: 'InputSelectSearch',

    components: {
        'v-select': vSelect,
    },

    props: {
        value: '',
        options: Array,
        label: String,
        placeholder: String,
        maxHeight: String,
        disabled: Boolean,
        multiple: {
            type: Boolean,
            default: false,
        },
        customClass: String,
        closeOnSelect: {
            type: Boolean,
            default: true,
        },
        appendToBody: {
            type: Boolean,
            default: false,
        },
        filter: {
            type: Function,
            default(options, search) {
                return options.filter(option => {
                    let label = this.getOptionLabel(option);
                    if (typeof label === "number") {
                        label = label.toString();
                    }
                    return this.filterBy(option, label, search);
                });
            }
        },
        clearable: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        selectValue() {
            return this.value === 0 ? null : this.value;
        }
    },

    methods: {
        onInput (value) {
            this.$emit('input', value)
        },
        onSearch (value) {
            this.$emit('search', value)
        },
    }
}
</script>

<style lang="scss">
@import '~#/globals';
.vs__dropdown-menu {
    max-height: 200px;
}
.dropdown {
    display: block;
}
.vue-select-bulma .vs__dropdown-option--highlight {
    background: $primary;
}
</style>
